import { put } from 'redux-saga/effects';
import { fetchAppRolesMappingFailure, fetchAppRolesMappingSuccess } from '../slice';
import apiClient from 'src/services/apiClient';
import { getUrl } from 'src/services/ApiService';

export function* getAppRolesMapping(action) {
    const { currentUserId, appId } = action.payload;
    const endpoint = `/iambff/v1/users/${currentUserId}/app-role-mappings?app_ids=${appId}`;
    const url = getUrl(endpoint);

    try {
        const result = yield apiClient.get(url, {
            cache: false,
        });
        const { connectedApps } = result.data;
        yield put(
            fetchAppRolesMappingSuccess({
                connectedApps,
            })
        );
    } catch (error) {
        const { message } = error;
        yield put(
            fetchAppRolesMappingFailure({
                message,
            })
        );
    }
}
